<template>
  <v-snackbar v-model="isShown" min-width="0" location="top" timeout="-1" content-class="error-snackbar__wrapper">
    <div v-if="config" class="error-snackbar">
      <e-icon class="mr-3 error-snackbar__icon" :name="config.icon" />
      <div class="paragraph-m_h">
        {{ config.title }}
      </div>
      <e-icon name="closeSvg" :size="18" class="ml-3 error-snackbar__close" @click="close" />
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { EIcon } from '@/core/components/ui';
import { useErrorSnackbar } from '@/core/composables/useErrorSnackbar';

const { config, isShown, closeErrorSnackbar } = useErrorSnackbar();

const close = () => {
  closeErrorSnackbar();
};
</script>

<style scoped lang="scss">
.error-snackbar {
  display: flex;
  align-items: center;

  font-weight: 600;
  color: $text-primary-color;

  &__close {
    flex-shrink: 0;

    cursor: pointer;
  }

  &__icon {
    flex-shrink: 0;
  }
}

:deep(.error-snackbar__wrapper) {
  margin: 0 12px;

  background: $alert-bg-color;
  border: 1px solid $alert-color;
  box-shadow: none;

  transition: transform $transition-duration;

  .v-snackbar__content {
    margin-right: 0;
    padding: 12px 11px 12px 14px;

    font-size: unset;
    line-height: unset;
    letter-spacing: unset;
  }
}
</style>
